import { CubeSide } from './cube-side';

export class Cube {
  public x: number;
  public y: number;
  public z: number;
  public position: number;
  public frontSide: CubeSide = new CubeSide('front');
  public backSide: CubeSide = new CubeSide('back');
  public leftSide: CubeSide = new CubeSide('left');
  public rightSide: CubeSide = new CubeSide('right');
  public topSide: CubeSide = new CubeSide('top');
  public bottomSide: CubeSide = new CubeSide('bottom');
  public sides: CubeSide[] = [
    this.frontSide,
    this.backSide,
    this.leftSide,
    this.rightSide,
    this.topSide,
    this.bottomSide,
  ];

  public colors: { color: string; backgroundColor: string }[] = [
    { backgroundColor: '#4a555c', color: '#adc4d2' },
    { backgroundColor: '#faaa0a', color: '#4a555c' },
    { backgroundColor: '#adc4d2', color: '#ffffff' },
    { backgroundColor: '#ffffff', color: '#faaa0a' },
    { backgroundColor: '#f498a2', color: '#ed5565' },
    { backgroundColor: '#9ce5d3', color: '#48cfad' },
  ];

  public get isCenter(): boolean {
    return (
      (this.x === 1 && this.y === 1) ||
      (this.x === 1 && this.z === 1) ||
      (this.y === 1 && this.z === 1)
    );
  }

  constructor(x: number, y: number, z: number) {
    this.x = x;
    this.y = y;
    this.z = z;
    this.updatePosition();
    this.updateSides();
  }

  private updatePosition(): void {
    this.position = this.x * 9 + this.y * 3 + this.z;
  }
  private updateSides() {
    this.updateFrontSite();
    this.updateBackSite();
    this.updateLeftSide();
    this.updateRightSide();
    this.updateTopSite();
    this.updateBottomSite();
  }
  private updateLeftSide(): void {
    if (this.z === 0) {
      this.leftSide.backgroundColor = this.colors[0].backgroundColor;
      this.leftSide.color = this.colors[0].color;
    }
  }
  private updateRightSide(): void {
    if (this.z === 2) {
      this.rightSide.backgroundColor = this.colors[5].backgroundColor;
      this.rightSide.color = this.colors[5].color;
    }
  }
  private updateFrontSite(): void {
    if (this.y === 0) {
      this.frontSide.backgroundColor = this.colors[1].backgroundColor;
      this.frontSide.color = this.colors[1].color;
    }
  }
  private updateBackSite(): void {
    if (this.y === 2) {
      this.backSide.backgroundColor = this.colors[2].backgroundColor;
      this.backSide.color = this.colors[2].color;
    }
  }
  private updateTopSite(): void {
    if (this.x === 0) {
      this.topSide.backgroundColor = this.colors[3].backgroundColor;
      this.topSide.color = this.colors[3].color;
    }
  }
  private updateBottomSite(): void {
    if (this.x === 2) {
      this.bottomSide.backgroundColor = this.colors[4].backgroundColor;
      this.bottomSide.color = this.colors[4].color;
    }
  }
}
